import { GetStorageComponent, getUserStorageComponent } from '../../../utils/storage';
import { UserStoreStateType, UserStoreState } from '../../user/types';

export default interface SessionStoreStateType {
  userid: string;
  access_token: string;
  token_type: string;
  refresh_token: string;
  expire_in: number;
  scope: string;
  user: UserStoreStateType;
  message: string;
}

export const SessionStoreState: SessionStoreStateType = {
  userid: GetStorageComponent('userid') || '',
  access_token: GetStorageComponent('access_token') || '',
  token_type: '',
  refresh_token: GetStorageComponent('refresh_token') || '',
  expire_in: 0,
  scope: '',
  message: '',
  user: getUserStorageComponent('userinfo') || UserStoreState,
};

export interface SessionActionType {
  type: string;
  payload: SessionStoreStateType;
}
